import Obi from './pictures/hello-there.gif'

const Fun = () => {
    return ( 
        <div className="funtime">
        <br/>
        <br/>
   
            <img src={Obi} alt="A" />
            <br /> 
            <h2>Looks like you came to learn about fun</h2>
                <br/>
              <body>
                  So I'm not sure if I can rank both of these categories by order of most favourite but I will try 
                  and see. 
              </body>

              <br/>

                <div class="row">
                    <div class="column">
                    <h3> <strong> Current Favourite Video Games</strong> </h3>
                    <li>Frost Punk</li>
                    <li> Skyrim </li>
                    <li> Stardew Valley</li>
                    <li> Lego Star Wars the Complete Saga </li>
                    <li> Overwatch (I don't play competitive, ruins the fun for me) </li>
                    <li> Age of Empires 4 (the series in general is fun)</li>
                    <li> Infamous 1 & 2 </li>
                    </div>

                     <div class="column">
                   <h3><strong>Current Favourite Animes </strong> </h3> 

                        <li>Gintama</li>
                        <li>One Piece</li>
                        <li>Code Geass</li>
                        <li>Deadman Wonderland</li>
                        <li>Gun X Sword (pretty good from what I remember)</li>
                        <li>Yu Yu Hakusho</li>

                    </div>
                </div>
                <br/>

                <body>
                    This list was actually a bit harder to compile than I thought. I had to look back and see what I've even watched and played,
                    but it will definitely need to be revisted as I think about this one more. 
                </body>

                <br/>
                <br/>

                <body>
                    So I talked about some other fun things I do in my about, but no evidence to back it up <strong>:</strong>o 
                </body>
                <br/>
                <body> 
                    I'm working on assembling a Gundam that I bought from Japan. I thought it was going to be pre-assembled (why I bought it)
                    but I was in for a surprise. The pieces are like those individual pieces you get for when you need to assemble something like a plastic car, 
                    like there are a lot of them so that should be fun. The best part ! The manual is all in japanese so this will be an adventure. I will 
                    upload pictures of it later on!
                </body>
                <br/>
                <body>
                    Last thing, I'm a pretty big LOTR and Star Wars fan. It's good stuff, good for your soul, just like food <strong>:</strong>) 
                </body>
                <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/><br/> <br/>
        </div>
     );
}
 
export default Fun;